import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import SalesReportTableRow from './SalesReportTableRow'
import {IReportSalesModel, ITotalSalesRow} from '../core/_models'

interface IProps {
    data: IReportSalesModel[];
    salesTotal?: ITotalSalesRow | null;
}

const SalesReportTable: FC<IProps> = ({data, salesTotal}) => {

    const {formatMessage} = useIntl()
    const [modalParam, setModalParam] = useState<{ show: boolean, data: IReportSalesModel | null }>({
        show: false,
        data: null
    });
    const toggleModal = (params?: IReportSalesModel) => {

        setModalParam((prev) => ({
            data: params ? params : prev.data,
            show: !modalParam.show
        }))
    }

    return (
        <>
            <table className='table align-middle gs-0 gy-5'>
                <thead>
                <tr>
                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'image'})}
                    </th>
                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'barcode'})}
                    </th>
                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'model_num'})}
                    </th>
                    <th className='fw-bold p-0 text-uppercase'>{formatMessage({id: 'prod_name'})}</th>
                    <th className='fw-bold p-0 px-2 text-uppercase'>{formatMessage({id: 'sold_qty'})}</th>

                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'avg_sale_price'})}
                    </th>
                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'total_sale_price'})}
                    </th>
                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'dumyah_fees'})}
                    </th>
                    <th className='fw-bold p-0 px-2 text-nowrap text-uppercase'>
                        {formatMessage({id: 'net'})}
                    </th>
                </tr>
                </thead>
                <tbody>
                {data && (
                    data.map((item, index) => (
                        <SalesReportTableRow
                            showDetails={toggleModal}
                            key={`${item.product_id}-${index}`}
                            item={item}
                        />
                    ))
                )}
                <>
                    <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{formatMessage({id: 'total'})} </td>
                        <td style={{
                            color: 'green',
                            borderTop: '1px solid #ccc'
                        }}>
                            {String(salesTotal?.total_quantity || 0)}
                        </td>
                        <td style={{borderTop: '1px solid #ccc'}}></td>
                        <td style={{
                            color: 'green',
                            borderTop: '1px solid #ccc'
                        }}>
                            {String(salesTotal?.total_sale_price || 0)}
                        </td>
                        <td style={{
                            color: 'green',
                            borderTop: '1px solid #ccc'
                        }}>
                            {String(salesTotal?.total_dumyah_fees || 0)}
                        </td>
                        <td style={{
                            color: 'green',
                            borderTop: '1px solid #ccc'
                        }}>
                            {String(salesTotal?.total_net || 0)}
                        </td>
                    </tr>
                </>
                </tbody>
            </table>
        </>
    )
}

export default SalesReportTable
